import React, {useState} from 'react'
import {
  SettingHeader,
  SettingInput,
  SettingMaster,
  SettingSite,
  SettingSubmit,
  SettingSwitch,
  SettingWrapper,
  SiteManageFooter
} from './styles';
import {Display} from '../Main/styles';
import {Input, Switch} from 'antd'
import {PlusOutlined} from '@ant-design/icons';
import type {UploadProps} from 'antd';
import {Button, message, Upload, UploadFile, Modal} from 'antd';
import API from 'utils/api';
import {useToken} from 'app/hooks';
import {useMyInfo} from 'CRM/hooks/GetMyInfo';
import {useSettingList} from 'CRM/hooks/GetSetting';
import {useIsMobile} from "../../components/IsMobile";

type FileType = File

const getBase64 = (file: FileType): Promise<string> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = (error) => reject(error);
  });

export const Setting = () => {
  const IsMobile = useIsMobile();
  const {data: token} = useToken();
  const {settingList} = useSettingList();
  const [current, setCurrent] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [re, setRe] = useState('');
  const [name, setName] = useState(settingList?.find(it => it.title == 'companyName')?.value);
  const [clickSwitch, setClickSwitch] = useState(settingList?.find(it => it.title == 'clickable')?.value);
  const [dragSwitch, setDragSwitch] = useState(settingList?.find(it => it.title == 'draggable')?.value);
  const favicon = process.env.REACT_APP_PUBLIC_URL + settingList?.find(it => it.title == 'favicon')?.value;
  const logo = process.env.REACT_APP_PUBLIC_URL + settingList?.find(it => it.title == 'logo')?.value;

  // ** 파비콘 이미지 업로드 관련
  const [previewOpenFavicon, setPreviewOpenFavicon] = useState(false);
  const [previewImageFavicon, setPreviewImageFavicon] = useState('');
  const [previewTitleFavicon, setPreviewTitleFavicon] = useState('');
  const [fileListFavicon, setFileListFavicon] = useState<UploadFile[]>([{uid: '-1', name: '회사 파비콘', url: favicon}])
  const handleCancelFavicon = () => setPreviewOpenFavicon(false);

  const handlePreviewFavicon = async (file: UploadFile) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj as FileType);
    }

    setPreviewImageFavicon(file.url || (file.preview as string));
    setPreviewOpenFavicon(true);
    setPreviewTitleFavicon(file.name || file.url!.substring(file.url!.lastIndexOf('/') + 1));
  };

  const handleChangeFavicon = ({fileList: newFileListFavicon}) => setFileListFavicon(newFileListFavicon);

  const uploadButtonFavicon = fileListFavicon.length >= 1 ? null : (
    <div>
      <PlusOutlined/>
      <div style={{marginTop: 8}}>Upload</div>
    </div>
  );

  // ** 로고 이미지 업로드 관련
  const [previewOpenLogo, setPreviewOpenLogo] = useState(false);
  const [previewImageLogo, setPreviewImageLogo] = useState('');
  const [previewTitleLogo, setPreviewTitleLogo] = useState('');
  const [fileListLogo, setFileListLogo] = useState<UploadFile[]>([{uid: '-1', name: '회사 로고', url: logo}])
  const handleCancelLogo = () => setPreviewOpenLogo(false);

  const handlePreviewLogo = async (file: UploadFile) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj as FileType);
    }

    setPreviewImageLogo(file.url || (file.preview as string));
    setPreviewOpenLogo(true);
    setPreviewTitleLogo(file.name || file.url!.substring(file.url!.lastIndexOf('/') + 1));
  };

  const handleChangeLogo = ({fileList: newFileListLogo}) => setFileListLogo(newFileListLogo);

  const uploadButtonLogo = fileListLogo.length >= 1 ? null : (
    <div>
      <PlusOutlined/>
      <div style={{marginTop: 8}}>Upload</div>
    </div>
  );


  const changePassword = () => {
    const shouldEdit = window.confirm(`비밀번호를 수정하시겠습니까?`);
    if (shouldEdit) {
      if (newPassword !== re) {
        message.error('신규 비밀번호가 일치하지 않습니다.')
      } else {
        API.put('/user/my/password', token + '', {
          currentPassword: current,
          newPassword: newPassword
        })
          .then((res: any) => {
            if (res.result.success) {
              message.success('수정되었습니다');
            } else if (res.result.mesage == 'password incorrect') {

              message.error('현재 비밀번호가 일치하지 않습니다.')
            }
          })
          .catch((err: any) => {
          })
      }
    }
  }

  const changeCompanyInfo = () => {
    const shouldEdit = window.confirm(`수정하실 내용이 맞습니까?\n회사명: ${name}\n 우클릭 방지: ${clickSwitch == true ? '예' : '아니오'} \n 드래그 방지: ${dragSwitch == true ? '예' : '아니오'}`);
    if (shouldEdit) {
      const targetFilesArrayFavicon = Array.from(fileListFavicon)
      const targetFilesArrayLogo = Array.from(fileListLogo)
      const formData = new FormData()

      targetFilesArrayLogo.forEach(file => {
        if (file.originFileObj) {
          formData.append('logo', file.originFileObj);
        }
      });

      targetFilesArrayFavicon.forEach(file => {
        if (file.originFileObj) {
          formData.append('favicon', file.originFileObj);
        }
      });

      formData.append('datas', JSON.stringify({
        list: [
          {
            title: 'companyName',
            value: name
          },
          {
            title: 'clickable',
            value: clickSwitch
          },
          {
            title: 'draggable',
            value: dragSwitch
          }
        ]
      }));

      API.postImage('PUT', '/system/settings', token + '', formData)
        .then((res: any) => {
          if (res.result.success) {
            message.success('수정되었습니다');
          }
        })
        .catch((err: any) => {
        })
    }
  }

  return (
    <Display IsMobile={IsMobile}>
      {IsMobile ?
        <SettingWrapper IsMobile={IsMobile}>
          <SettingMaster>
            <SettingHeader>최고관리자 정보수정</SettingHeader>
            <SettingInput>
              <label htmlFor='current'>현재 비밀번호</label>
              <Input type='password' id='current' value={current} onChange={(e) => setCurrent(e.target.value)}
                     placeholder='현재 비밀번호 입력'/>
            </SettingInput>
            <SettingInput>
              <label htmlFor='new'>신규 비밀번호</label>
              <Input type='password' id='new' value={newPassword} onChange={(e) => setNewPassword(e.target.value)}
                     placeholder='새 비밀번호 입력'/>
            </SettingInput>
            <SettingInput>
              <label htmlFor='re'>신규 비밀번호 확인</label>
              <Input type='password' id='re' value={re} onChange={(e) => setRe(e.target.value)}
                     placeholder='새 비밀번호 확인'/>
            </SettingInput>
            <SettingSubmit onClick={changePassword}>저장</SettingSubmit>
          </SettingMaster>
          <SettingSite>
            <SettingHeader>사이트 관리</SettingHeader>
            <SettingInput>
              <label htmlFor='name'>회사명</label>
              <Input type='text' id='name' value={name} onChange={(e) => setName(e.target.value)}
                     placeholder='현재 비밀번호 입력'/>
            </SettingInput>
            <SettingInput>
              <label htmlFor='favicon'>파비콘</label>
              <Upload
                action="https://run.mocky.io/v3/435e224c-44fb-4773-9faf-380c5e6a2188"
                listType="picture-card"
                fileList={fileListFavicon}
                onPreview={handlePreviewFavicon}
                onChange={handleChangeFavicon}
              >
                {uploadButtonFavicon}
              </Upload>
              <Modal open={previewOpenFavicon} title={previewTitleFavicon} footer={null} onCancel={handleCancelFavicon}>
                <img alt="example" style={{width: '100%'}} src={previewImageFavicon}/>
              </Modal>
            </SettingInput>
            <SettingInput>
              <label htmlFor='logo'>회사로고</label>
              <Upload
                action="https://run.mocky.io/v3/435e224c-44fb-4773-9faf-380c5e6a2188"
                listType="picture-card"
                fileList={fileListLogo}
                onPreview={handlePreviewLogo}
                onChange={handleChangeLogo}
              >
                {uploadButtonLogo}
              </Upload>
              <Modal open={previewOpenLogo} title={previewTitleLogo} footer={null} onCancel={handleCancelLogo}>
                <img alt="example" style={{width: '100%'}} src={previewImageLogo}/>
              </Modal>
            </SettingInput>
            <SiteManageFooter>
              <SettingInput>
                <SettingSwitch>
                  <label htmlFor='click'>우클릭 방지</label>
                  <Switch value={clickSwitch} onChange={() => setClickSwitch(!clickSwitch)}/>
                </SettingSwitch>
                <SettingSwitch>
                  <label htmlFor='click'>드래그 방지</label>
                  <Switch value={dragSwitch} onChange={() => setDragSwitch(!dragSwitch)}/>
                </SettingSwitch>
              </SettingInput>
              <SettingSubmit onClick={changeCompanyInfo}>저장</SettingSubmit>
            </SiteManageFooter>
          </SettingSite>
        </SettingWrapper>
        :
        <SettingWrapper>
          <SettingMaster>
            <SettingHeader>최고관리자 정보수정</SettingHeader>
            <SettingInput>
              <label htmlFor='current'>현재 비밀번호</label>
              <Input type='password' id='current' value={current} onChange={(e) => setCurrent(e.target.value)}
                     placeholder='현재 비밀번호 입력'/>
            </SettingInput>
            <SettingInput>
              <label htmlFor='new'>신규 비밀번호</label>
              <Input type='password' id='new' value={newPassword} onChange={(e) => setNewPassword(e.target.value)}
                     placeholder='새 비밀번호 입력'/>
            </SettingInput>
            <SettingInput>
              <label htmlFor='re'>신규 비밀번호 확인</label>
              <Input type='password' id='re' value={re} onChange={(e) => setRe(e.target.value)}
                     placeholder='새 비밀번호 확인'/>
            </SettingInput>
            <SettingSubmit onClick={changePassword}>저장</SettingSubmit>
          </SettingMaster>
          <SettingSite>
            <SettingHeader>사이트 관리</SettingHeader>
            <SettingInput>
              <label htmlFor='name'>회사명</label>
              <Input type='text' id='name' value={name} onChange={(e) => setName(e.target.value)}
                     placeholder='현재 비밀번호 입력'/>
            </SettingInput>
            <SettingInput>
              <label htmlFor='favicon'>파비콘</label>
              <Upload
                action="https://run.mocky.io/v3/435e224c-44fb-4773-9faf-380c5e6a2188"
                listType="picture-card"
                fileList={fileListFavicon}
                onPreview={handlePreviewFavicon}
                onChange={handleChangeFavicon}
              >
                {uploadButtonFavicon}
              </Upload>
              <Modal open={previewOpenFavicon} title={previewTitleFavicon} footer={null} onCancel={handleCancelFavicon}>
                <img alt="example" style={{width: '100%'}} src={previewImageFavicon}/>
              </Modal>
            </SettingInput>
            <SettingInput>
              <label htmlFor='logo'>회사로고</label>
              <Upload
                action="https://run.mocky.io/v3/435e224c-44fb-4773-9faf-380c5e6a2188"
                listType="picture-card"
                fileList={fileListLogo}
                onPreview={handlePreviewLogo}
                onChange={handleChangeLogo}
              >
                {uploadButtonLogo}
              </Upload>
              <Modal open={previewOpenLogo} title={previewTitleLogo} footer={null} onCancel={handleCancelLogo}>
                <img alt="example" style={{width: '100%'}} src={previewImageLogo}/>
              </Modal>
            </SettingInput>
            <SiteManageFooter>
              <SettingInput>
                <SettingSwitch>
                  <label htmlFor='click'>우클릭 방지</label>
                  <Switch value={clickSwitch} onChange={() => setClickSwitch(!clickSwitch)}/>
                </SettingSwitch>
                <SettingSwitch>
                  <label htmlFor='click'>드래그 방지</label>
                  <Switch value={dragSwitch} onChange={() => setDragSwitch(!dragSwitch)}/>
                </SettingSwitch>
              </SettingInput>
              <SettingSubmit onClick={changeCompanyInfo}>저장</SettingSubmit>
            </SiteManageFooter>
          </SettingSite>
        </SettingWrapper>
      }

    </Display>
  )
}

export default React.memo(Setting);